import { ref } from 'vue';

export default function reusableVersion() {
  const SemanticVersion = ref('Vol PH-1');
  return {
    SemanticVersion
  };
}
